import React from 'react';

const PatientRecords = () => {
  const medicalHistory = [
    { condition: 'Diabetes', diagnosed: '2018-04-15', notes: 'Managed with oral medication' },
    { condition: 'Hypertension', diagnosed: '2020-01-10', notes: 'Stable, regular monitoring' },
  ];
  const reports = [
    {
      name: 'Blood Test',
      date: '2025-06-01',
      issuedBy: 'Dr. John Smith',
      status: 'Completed',
      link: '#',
    },
    {
      name: 'X-Ray Chest',
      date: '2025-05-22',
      issuedBy: 'Radiology Lab',
      status: 'Completed',
      link: '#',
    },
    {
      name: 'Urine Analysis',
      date: '2025-05-15',
      issuedBy: 'PathCare Lab',
      status: 'Completed',
      link: '#',
    },
    {
      name: 'MRI Brain',
      date: '2025-04-28',
      issuedBy: 'City Scan Center',
      status: 'Pending',
      link: '#',
    },
  ];

  const labTests = [
    { test: 'CBC', date: '2025-05-10', result: 'Normal' },
    { test: 'Lipid Profile', date: '2025-04-18', result: 'Slightly Elevated Cholesterol' },
  ];

  const prescriptions = [
    { medicine: 'Metformin', prescribedBy: 'Dr. John Smith', date: '2025-05-01', dosage: '500mg, twice daily' },
    { medicine: 'Amlodipine', prescribedBy: 'Dr. Sarah Lee', date: '2025-04-22', dosage: '5mg, once daily' },
  ];

  const vaccinations = [
    { vaccine: 'Influenza', date: '2024-11-01', provider: 'City Clinic' },
    { vaccine: 'COVID-19 Booster', date: '2024-09-15', provider: 'Apollo Health' },
  ];

  return (
    <div style={{ padding: '20px' }}>

      <h3>Patient Reports</h3>

      <table className="full-width-table">
        <thead>
          <tr>
            <th>Report</th>
            <th>Date</th>
            <th>Issued By</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {reports.map((report, index) => (
            <tr key={index}>
              <td>{report.name}</td>
              <td>{report.date}</td>
              <td>{report.issuedBy}</td>
              <td>{report.status}</td>
              <td>
                {report.status === 'Completed' ? (
                  <a href={report.link} target="_blank" rel="noopener noreferrer">
                    View
                  </a>
                ) : (
                  'Not available'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <h3>Medical History</h3>
      <table className="full-width-table">
        <thead>
          <tr>
            <th>Condition</th>
            <th>Diagnosed On</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {medicalHistory.map((item, index) => (
            <tr key={index}>
              <td>{item.condition}</td>
              <td>{item.diagnosed}</td>
              <td>{item.notes}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ marginTop: '30px' }}>Lab Test Results</h3>
      <table className="full-width-table">
        <thead>
          <tr>
            <th>Test</th>
            <th>Date</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          {labTests.map((test, index) => (
            <tr key={index}>
              <td>{test.test}</td>
              <td>{test.date}</td>
              <td>{test.result}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ marginTop: '30px' }}>Prescriptions</h3>
      <table className="full-width-table">
        <thead>
          <tr>
            <th>Medicine</th>
            <th>Prescribed By</th>
            <th>Date</th>
            <th>Dosage</th>
          </tr>
        </thead>
        <tbody>
          {prescriptions.map((item, index) => (
            <tr key={index}>
              <td>{item.medicine}</td>
              <td>{item.prescribedBy}</td>
              <td>{item.date}</td>
              <td>{item.dosage}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ marginTop: '30px' }}>Vaccination Records</h3>
      <table className="full-width-table">
        <thead>
          <tr>
            <th>Vaccine</th>
            <th>Date</th>
            <th>Provider</th>
          </tr>
        </thead>
        <tbody>
          {vaccinations.map((item, index) => (
            <tr key={index}>
              <td>{item.vaccine}</td>
              <td>{item.date}</td>
              <td>{item.provider}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PatientRecords;
